import { render, staticRenderFns } from "./admin-exam-sciences.vue?vue&type=template&id=8e5fd43c&scoped=true"
import script from "./admin-exam-sciences.vue?vue&type=script&lang=js"
export * from "./admin-exam-sciences.vue?vue&type=script&lang=js"
import style0 from "./admin-exam-sciences.vue?vue&type=style&index=0&id=8e5fd43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5fd43c",
  null
  
)

export default component.exports